/** It checks if property is a string to be processed by the passed function, if not it returns the property itself */
export const handleStringified = (property: any, fn: (str: string) => any) => {
  if (!property) return undefined;

  if (typeof property === 'string') {
    return fn(property);
  }
  return property;
};
